import { TransactionFiltersDTO } from "../models/Transaction";
import { UpdateValues } from "../validation/RegisterValidation";
import axiosInstance from "./axiosInstance";

const changePassword = async (data: {
  oldPassword: string;
  newPassword: string;
}) => {
  const response = await axiosInstance.patch("auth/update/password", data);

  return response.data;
};

const updateUser = async (user: Partial<UpdateValues>) => {
  const response = await axiosInstance.post("user/update", user);
  return response.data;
};

const getAllCustomers = async () => {
  const response = await axiosInstance.get("customer/all");
  return response.data;
};

const getCustomerById = async (id: string) => {
  const response = await axiosInstance.get(`customer/${id}`);
  return response.data;
};

const createWithdrawalRequest = async (data: { amount: number }) => {
  const response = await axiosInstance.post("withdrawals/create", data);
  return response.data;
};



const getAllWithdrawForCustomer = async (filters: TransactionFiltersDTO) => {
  const response = await axiosInstance.get("withdrawals/all", {
    params: {
      status: filters.status,
      startDate: filters.startDate,
      endDate: filters.endDate,
    },
  });
  return response.data;
};
const getAllWithdrawals = async (filters: TransactionFiltersDTO) => {
  const response = await axiosInstance.get("withdrawals/admin/all", {
    params: {
      status: filters.status,
      startDate: filters.startDate,
      endDate: filters.endDate,
    },
  });
  return response.data;
};

const getOneWithdrawal = async (withdrawalId: string) => {
  const response = await axiosInstance.get(`withdrawals/detail/${withdrawalId}`);
  return response.data;
};

const manageWithdrawal = async (
  action: 'approve' | 'reject',
  data: { withdrawId: string, adminNotes:string } 
) => {
  const response = await axiosInstance.post(`withdrawals/admin/manage/${action}`, data);
  return response.data;
};

interface CreateWebhookDto {
  url: string;
  events?: string[];
  isActive?: boolean;
}

interface UpdateWebhookDto {
  url?: string;
  events?: string[];
  isActive?: boolean;
}

interface FilterWebhooksDto {
  isActive?: boolean;
  event?: string;
}

const createWebhook = async (data: CreateWebhookDto) => {
  const response = await axiosInstance.post("webhooks", data);
  return response.data;
};

const getUserWebhooks = async () => {
  const response = await axiosInstance.get("webhooks");
  return response.data;
};

const updateWebhook = async (id: string, data: UpdateWebhookDto) => {
  const response = await axiosInstance.put(`webhooks/${id}`, data);
  return response.data;
};

const deleteWebhook = async (id: string) => {
  const response = await axiosInstance.delete(`webhooks/${id}`);
  return response.data;
};

const getAllWebhookEvents = async (): Promise<string[]> => {
  const response = await axiosInstance.get("webhooks/events/available");
  return response.data;
};



export const UserService = {
  changePassword,
  updateUser,
  getAllCustomers,
  getCustomerById,
  createWithdrawalRequest,
  getAllWithdrawForCustomer,
  getOneWithdrawal,
  getAllWithdrawals,
  manageWithdrawal,
  createWebhook,
  getUserWebhooks,
  updateWebhook,
  deleteWebhook,
  getAllWebhookEvents,
};
